/* Decode a JWT payload without verifying the signature — used only to read the exp claim
   on the client. Never trust this for security; the backend still verifies every request. */
const decodeToken = token => {
    try {
        const part = token.split(".")[1]
        const base64 = part.replace(/-/g, "+").replace(/_/g, "/")
        const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4)
        return JSON.parse(atob(padded))
    }
    catch (error) {
        /* Malformed token — treat it as invalid */
        return null
    }
}

/* A token is valid only if it decodes and its exp claim is still in the future */
export const isTokenValid = token => {
    if (!token) {
        return false
    }
    const payload = decodeToken(token)
    if (!payload || !payload.exp) {
        return false
    }
    return payload.exp * 1000 > Date.now()
}

/* Clear an expired/invalid session so the UI (header, booking guards) reflects reality.
   Dispatches only when there is actually a stale token, to avoid needless re-renders. */
export const checkToken = store => {
    const token = localStorage.getItem("token")
    if (token && !isTokenValid(token)) {
        store.dispatch({ type: "REMOVE_TOKEN" })
        store.dispatch({ type: "REMOVE_USER" })
        return false
    }
    return !!token
}
